export default function badgeClass(string, data) {
  let badgeClass = 'other-badge';

  if (string === 'size') {
    if (data.includes('Portrait')) badgeClass = 'portrait-badge';
    if (data.includes('Landscape')) badgeClass = 'landscape-badge';
  }

  if (string === 'user_label') {
    badgeClass = 'user-label-badge';
  }
  
  return badgeClass;
}
